import { http } from '../../../plugins/axios'

const actions = {
  get ({commit, dispatch}, payload) {
    let url = `questionnaires`
    let options = {
      emulateJSON: false
    }
    let params = {
      "page": payload.event.item.page,
      "perPage": payload.event.item.perPage,
      "sortKey": payload.event.item.sortKey ? payload.event.item.sortKey : 'id',
      "ord": payload.event.item.ord,
      "find": payload.event.item.find !== '' ? payload.event.item.find : undefined
    }
    http.get(url, { params }, options)
      .then(response => {
        commit('onGet',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  getById ({commit, dispatch}, payload) {
    let url = `questionnaires/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(response => {
        commit('onGetById',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  post ({commit, dispatch}, payload) {
    let url = 'questionnaires'
    let options = {
      emulateJSON: false
    }
    http.post(url, payload.event.test, options)
      .then(response => {
        commit('onPost',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  put ({commit, dispatch}, payload) {
    let url = `questionnaires/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.put(url, payload.event.test, options)
      .then(response => {
        commit('onPut',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  delete ({commit, dispatch}, payload) {
    let url = `questionnaires/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.delete(url, {}, options)
      .then(response => {
        commit('onDelete',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  deleteQuestion ({commit, dispatch}, payload) {
    let url = `questionnaires/delete/questions/${payload.event.questionId}/${payload.event.sectionId}`
    let options = {
      emulateJSON: false
    }
    http.delete(url, {}, options)
      .then(response => {
        commit('onDeleteQuestion',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  deleteSection ({commit, dispatch}, payload) {
    let url = `questionnaires/delete/section/${payload.event.sectionId}/${payload.event.testId}`
    let options = {
      emulateJSON: false
    }
    http.delete(url, {}, options)
      .then(response => {
        commit('onDeleteSection',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  defaultQuestionnaires ({commit, dispatch}, payload) {
    let url = 'questionnaires-default'
    let options = {
      emulateJSON: false
    }
    let params = {
      "country_id": payload.event.item.country_id,
      "sites": payload.event.item.sites,
      "unit_types_id": payload.event.item.unit_type,
      "questionnaires_unit_types": payload.event.item.templates,
      "type": payload.event.item.type
    }
    http.post(url, params, options)
      .then(response => {
        commit('onPost',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
        payload.event.context.loadButton = false
      })
  },
  customQuestionnaires ({commit}, payload) {
    let url = 'custom-questionnaires'
    let options = {
      emulateJSON: false
    }
    http.get(url, options)
      .then(response => {
        commit('onCustomQuestionnaires',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  questionnaireDefault ({commit, dispatch}, payload) {
    let url = `questionnaires-default/template`
    let options = {
      emulateJSON: false
    }
    let params = {
      "type": payload.event.type
    }
    http.get(url, { params }, options)
      .then(response => {
        commit('onQuestionnaireDefault',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
        payload.event.context.loadingTemplate = false
      })
  },
}

export default actions